export default {
  cameras: state => {
    return state.cameras;
  },
  cameraById: state => id => {
    const filtered = state.cameras.filter(item => {
      return parseInt(item.id) === parseInt(id);
    });

    return filtered && filtered.length > 0 ? filtered[0] : null;
  },
  motionCycle: state => {
    return state.motionCycle;
  }
};